import { Link, useNavigate } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import styles from 'pages/Promotions/styles/promo.module.css';
import { useEffect } from 'react';

interface ModalBackdropNotFoundProps {
  isNotFound: boolean;
  setIsNotFound: (value: boolean) => void;
  message: string;
  redirect?: string;
  ButtonMsg: string;
  AutoCloseTime?: number;
  icon?: string;
  // showButton?: boolean;
}

const ModalBackdropNotFound = ({
  isNotFound,
  setIsNotFound,
  message,
  redirect = '',
  ButtonMsg,
  AutoCloseTime = 5000,
  icon = '',
}: // showButton = true,
ModalBackdropNotFoundProps) => {
  // const { t } = useTranslation();
  const history = useNavigate();

  const closeModal = () => {
    setIsNotFound(false);
  };

  useEffect(() => {
    if (isNotFound) {
      const timer = setTimeout(() => {
        if (redirect !== '') {
          history(redirect);
        }
        setIsNotFound(false);
      }, AutoCloseTime);

      return () => clearTimeout(timer);
    }
  }, [isNotFound, history, redirect, setIsNotFound, AutoCloseTime]);

  return (
    <Modal
      isOpen={isNotFound}
      toggle={closeModal}
      backdrop={'static'}
      id="staticBackdropNotFound"
      centered
      data-testid="modal-not-found"
    >
      <ModalHeader
        className="d-flex align-items-center justify-content-between"
        // toggle={() => dispatch(setModalBackdrop(false))} //? Top Right Corner X button
      >
        {/* <h5 className="modal-title" id="staticBackdropLabel">
          Modal title
        </h5> */}
      </ModalHeader>
      <ModalBody className="text-center p-5">
        <i className={`bx bx-error-circle display-4 text-warning`}></i>

        <div className="mt-4">
          <h4 className="mb-3">{message}</h4>

          <br />

          <div className="hstack gap-2 justify-content-center">
            <Link
              to={redirect === '' ? '#' : redirect}
              className={`btn ${styles['custom-violet-btn']}`}
              onClick={closeModal}
            >
              {ButtonMsg}{' '}
              {icon !== '' ? <i className={`${icon} align-middle`}></i> : null}
            </Link>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalBackdropNotFound;
